import apiClient from "../axios";

function getShops() {
  return apiClient.get("/shops");
}

export { getShops};
